export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";